import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-46" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-49" data-mp="57ebob4uv5ec">
            <span aria-hidden="true" data-id="element-50" data-mp="3mfsxp4dt4r2a">🔬 </span>Der YOGA BEREIT™ Unterschied
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-51" data-mp="3rh8kb0vmv5ms">
            Von der erschöpften Lehrerin zur{' '}
            <span className="italic text-brand" data-id="element-52" data-mp="3if91q44yzthq">selbstbewussten Führung.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-53" data-mp="1borosrrtdtwx">
            Verleihe deinem Unterricht eine professionelle visuelle Wirkung, schenke deinen Schülern
            eine tiefgreifende Erfahrung und gewinne die Zeit zurück, um deine Leidenschaft für das
            Unterrichten wieder zu genießen.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-54" data-mp="1f7r4dbxp8gwe">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-55" data-mp="1o3ypwsoxk9mz" data-mpi={index}>
              <dt className="sr-only" data-id="element-56" data-mp="1aah9vhvgdf1p">{stat.label}</dt>
              <dd data-id="element-57" data-mp="1ac2394616rxz">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-58" data-mp="1a8e7rzh0zvgm">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-59" data-mp="2lp4jfy47xfhm">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-60" data-mp="2oq7f3239d4pe">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2ssaz4f3zthma">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-62" data-mp="2sr145ysfspjv">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-63" data-mp="2xsyrp57ve6im">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="32oxmbajskkrh" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-65" data-mp="2552xc75rwqp0">
                Vor Yoga Bereit™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-66" data-mp="2f0xl1goutbyn">
                Die Kosten der Improvisation
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="1md1oqd375m2e">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-68" data-mp="1rbv2m6mebf33">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-69" data-mp="1jpzqcr1y1p25" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-70" data-mp="19vzbhxgv15g8">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-71" data-mp="14ua0ghtn0rs5">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="10vayn637db4x" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-73" data-mp="w0on92x4fiku">
                Mit Yoga Bereit™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-74" data-mp="m5d5scubvx9e">
                Das ultimative System
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-75" data-mp="d3dn7g3o0l4c">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-76" data-mp="11uteccm3zdlp">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-77" data-mp="t2hkegrsd80z" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-78" data-mp="j3selmd5ze13">
            Ein komplettes System: weniger planen, mit mehr Leidenschaft unterrichten.
          </p>
        </div>
      </div>
    </section>;
}